import {IEventData} from 'coreClasses/events/IEvents';
import {IAnalyticsEvent} from 'coreClasses/analytics/IAnalytics';

import {EAnalyticsEventType} from 'brandClasses/analytics/EAnalyticsEvent';

import WishlistInfoModel from './common/WishlistInfoModel';

/**
 * Represents WishlistUpdatedEvent
 */
export default class WishlistUpdatedEvent implements IAnalyticsEvent {
	public event: string;
	public event_trigger: string;
	public wishlist_info: WishlistInfoModel;
	/**
	 * @constructor
	 * @param {IEventData} data - data
	 */
	constructor(data: IEventData) {
		this.event = EAnalyticsEventType.WISHLIST_UPDATED;
		this.event_trigger = 'ecomm';

		const wishlist = data.wishlist;
		const products = data.products;

		this.wishlist_info = data.wishlist && new WishlistInfoModel(wishlist, products);
	}
}
